import axios from "axios";
import { TTP_API_URL } from "Config";

export const getTTPUser = ({ userId, token }) => {
  const filter = [
    {
      property: "id",
      value: userId,
      operator: "eq"
    }
  ];

  const fields = [
    "*",
    // "communities",
    "uid",
    "adminisId",
    "avatar",
    "description",
    "contactSocialNetworks",
    "cover",
    "url",
    "role",
    "accountingUserOrganizations",
    "selectedOrganization"
  ];

  const requestUrl = `${TTP_API_URL}/organization/user`;

  let params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(","),
    workspace: "ua"
  };

  return axios.get(requestUrl, {
    //cancelToken: getLatestArticlesSourceToken.token,
    params
  });
};

export const setCurrentOrganization = (token, client) => {
  const requestUrl = `${TTP_API_URL}/organization/user/save-selected-organization`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("organizationId", client.id);

  return axios.post(requestUrl, formData);
};

export const getPartners = (token, organizationId) => {
  const requestUrl = `${TTP_API_URL}/team/partners`;

  let params = {
    access_token: token,
    organizationId
  };

  return axios.get(requestUrl, {
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/auth.js